import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMediaPopupStore = defineStore('mediaPopup', () => {
  const contextList = ref(null);

  function setMediaContextList({ mediaContextList }) {
    contextList.value = mediaContextList;
  }

  function clearMediaContextList() {
    contextList.value = null;
  }

  return {
    contextList,
    setMediaContextList,
    clearMediaContextList,
  };
});
